import { IconProps } from "./";
import Icon from "./assets/chat_msg_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24ChatMessage(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
